import React from 'react';
import { useDispatch } from 'react-redux';
import { hideGlobalMessage } from '../../../../actions/globalMessage';
import { showWaitingAreaLogoPauseImageModal } from '../../../../actions/modal';

import Info from '../../info';
import { NetworkTypes } from '../../../../constants/networkTypes.js';

export default function RightPanelUpdate(props) {
  const dispatch = useDispatch();

  const LogoImageUpdate = (e) => {
    props.saveLogoPauseImage();
  };

  const cancelUpdateLogoPauseImage = () => {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) dispatch(hideGlobalMessage());
    resetForm();
  };

  const resetForm = () => {
    dispatch(showWaitingAreaLogoPauseImageModal(false));
  };

  let saveClasses =
    'ui labeled icon button icon color-button color-button-hover color-white max-width left-text mrlnull mrbnull';
  return (
    <div>
      <div className="ui actions mrbl mrtxxs">
        <div data-show={!props.readOnly}>
          <button
            tabIndex="4"
            type="button"
            onClick={LogoImageUpdate}
            className={props.waitingAreaLogoPauseImageForm.isSaving ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark  icon" />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={cancelUpdateLogoPauseImage}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
        <div data-show={props.readOnly}>
          <button
            tabIndex="5"
            type="button"
            onClick={cancelUpdateLogoPauseImage}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width  mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      </div>
      <div data-show={!props.readOnly}>
        <Info
          paragraphs={
            props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation
              ? [
                  APP.LANGUAGE.WaitingAreaLogoPauseImage.ImageInfoPart,
                  APP.LANGUAGE.WaitingAreaLogoPauseImage.ImageInfoPartGC,
                ]
              : [APP.LANGUAGE.WaitingAreaLogoPauseImage.ImageInfoPart]
          }
        />
      </div>
    </div>
  );
}
